import type { StorageType } from '@mimir/common/dto/storageModel';
import type { ItemMetaData } from '@mimir/common/dto/fieldValue';
import type { ItemAccessControl } from '@mimir/common/dto/itemAccessControlDto';

export const ICONS = {
  PROGRESSING: 'hourglass_empty',
  COMPLETE: 'check_circle',
  ERROR: 'error',
  DELETING: 'delete_sweep',
  DISABLED: 'remove_circle',
  INFO: 'info',
};

export enum SrtType {
  Standard = 'standard',
  Avid = 'avid',
}

export type TranscriptChoice = 'paragraph' | 'subtitle';

export interface SubtitleDownloadConfig {
  type: SrtType;
  language: string;
  timecode?: string;
  mediaFrameRate?: number;
  option?: TranscriptChoice;
  extension?: string;
}

export type StorageSelectParamsType = {
  clipName: string | undefined;
  storage?: StorageType;
  shouldCreateVisibleItemForSubclip?: boolean;
  subclipItemMetadata?: ItemMetaData;
  visibleTo: ItemAccessControl | undefined;
  updatableBy: ItemAccessControl | undefined;
};

